// gimme: conversations-inbox-ui/ 06/02/2020 5f1e15ece5fe518f7ad7313590340d8fe6192284
'use es6';

export const CACHE_RESPONDERS = 'CACHE_RESPONDERS';
export const REASSIGN_CONVERSATION = 'REASSIGN_CONVERSATION';
export const REASSIGN_CONVERSATION_SUCCEEDED = 'REASSIGN_CONVERSATION_SUCCEEDED';
export const REASSIGN_CONVERSATION_FAILED = 'REASSIGN_CONVERSATION_FAILED';
export const UNASSIGN_CONVERSATION = 'UNASSIGN_CONVERSATION';
export const UNASSIGN_CONVERSATION_SUCCEEDED = 'UNASSIGN_CONVERSATION_SUCCEEDED';
export const UNASSIGN_CONVERSATION_FAILED = 'UNASSIGN_CONVERSATION_FAILED';